/**
 * The runtime platform-brand pointer (TO-541, ADR-0045 Amendment TO-541): which
 * compiled catalogue brand binds `/login`, the `SUPER_ADMIN` backoffice and every
 * "no usable tenant brand" fallback. Only the id is runtime; brand content stays
 * compiled.
 */

/** The key of one platform-wide setting row (`users_platform_settings.setting_key`). */
export enum PlatformSettingKey {
	PLATFORM_BRAND_ID = 'platform_brand_id',
}

/** The outcome of projecting a switched pointer to the fast parameter store (REQ-005). */
export enum PlatformBrandProjection {
	/** The parameter holds the new value. */
	APPLIED = 'APPLIED',
	/** Every write failed; the parameter was deleted so readers self-heal from the stored setting. */
	PENDING = 'PENDING',
}

/** `GET /platform/brand` — the resolved platform brand id. */
export interface PlatformBrandDTO {
	brandId: string
}

/** `PUT /admin/platform/brand` — the switch outcome. */
export interface PutPlatformBrandResponseDTO {
	brandId: string
	/** The effective pointer before the request; equals `brandId` for a no-op. */
	previousBrandId: string
	changed: boolean
	projection: PlatformBrandProjection
}
